import { ReportIcon } from '../icons';
import { Badge } from '../Badge';
import { Button } from '../Button';
import { useReportBasket } from './ReportBasketContext';

/** Bouton de l'en-tête : ouvre le panier du rapport composé, avec le nombre d'éléments. */
export function ReportBasketButton() {
  const { items, drawerOpen, openDrawer } = useReportBasket();
  const count = items.length;
  const label = count
    ? `Rapport à générer : ${count} élément${count > 1 ? 's' : ''}`
    : 'Rapport à générer : vide';
  return (
    <Button
      iconOnly
      icon={ReportIcon}
      iconSize={18}
      className={`header-icon-button report-basket-button ${count ? 'has-items' : ''}`}
      aria-haspopup="dialog"
      aria-expanded={drawerOpen}
      aria-label={label}
      title={count ? label : 'Rapport à générer : ajoutez des visuels avec « Ajouter au rapport »'}
      onClick={(event) => openDrawer(event.currentTarget)}
    >
      {count > 0 && <Badge count={count} className="report-basket-button__count" aria-hidden="true" />}
    </Button>
  );
}
